
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/um/thjonusta/leidbeiningar/skraning-i-simaskra",
      function () {
        return require("private-next-pages/um/thjonusta/leidbeiningar/skraning-i-simaskra.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/um/thjonusta/leidbeiningar/skraning-i-simaskra"])
      });
    }
  